export type EquipmentType = 'cycle' | 'run' | 'fusion' | 'rower' | 'strength';
export type DeviceType = 'tablet' | 'mobile';
export type UserType = 'premium' | 'free' | 'anonymous';
export type Platform = 'phone' | 'small-tablet' | 'tablet';

declare global {
  interface Window {
    callJavaScript: (payload: string) => void;
  }
}

export type WebviewError = {
  from: string;
  stack: string;
};

export type Action<T> = {
  type: string;
  value: T;
};

export enum FeatureFlag {
  Challenges = 'featureflag://flag?key=challenge-store&type=bool',
  LiveWorkouts = 'featureflag://flag?key=live-workouts-row&type=bool',
}

export type FeatureFlags = Record<FeatureFlag, boolean>;

// Declaring Partial<FeatureFlags> as individual featureFlags from native
// may or may not exist, e.g. depending on the environment, flag is WIP, etc.
export interface WaitForDataResponse extends Partial<FeatureFlags> {
  echo: string;
  errors?: string;
  methodName: string;
}
